var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTrade({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.345 0.5H2.155C1.24097 0.5 0.5 1.24097 0.5 2.155V5.345C0.5 6.25903 1.24097 7 2.155 7H5.345C6.25903 7 7 6.25903 7 5.345V2.155C7 1.24097 6.25903 0.5 5.345 0.5Z",
    fill: "#2894FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.845 0.5H10.655C9.74097 0.5 9 1.24097 9 2.155V5.345C9 6.25903 9.74097 7 10.655 7H13.845C14.759 7 15.5 6.25903 15.5 5.345V2.155C15.5 1.24097 14.759 0.5 13.845 0.5Z",
    fill: "#2894FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.345 9H2.155C1.24097 9 0.5 9.74097 0.5 10.655V13.845C0.5 14.759 1.24097 15.5 2.155 15.5H5.345C6.25903 15.5 7 14.759 7 13.845V10.655C7 9.74097 6.25903 9 5.345 9Z",
    fill: "#2894FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 15.5C14.0449 15.5 15.5 14.0449 15.5 12.25C15.5 10.4551 14.0449 9 12.25 9C10.4551 9 9 10.4551 9 12.25C9 14.0449 10.4551 15.5 12.25 15.5Z",
    fill: "#2894FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTrade);
export default __webpack_public_path__ + "static/media/social_trade.6b02593ce0577bc83066bbc7f675f412.svg";
export { ForwardRef as ReactComponent };